import * as React from "react";

interface IProps {
  className?: string;
  fill?: string;
  size?: number | string;
}

export const AsanaLogo = ({ className = undefined, size = "100%" }: IProps) => (
  <svg
    className={className}
    style={{ width: size, height: size }}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5207 10.331C13.9848 10.331 11.9292 12.3866 11.9292 14.9226C11.9292 17.4585 13.9848 19.5141 16.5207 19.5141C19.0565 19.5141 21.1122 17.4585 21.1122 14.9226C21.1122 12.3866 19.0565 10.331 16.5207 10.331ZM4.59151 10.3313C2.05571 10.3313 0 12.3867 0 14.9226C0 17.4585 2.05571 19.5142 4.59151 19.5142C7.12742 19.5142 9.18323 17.4585 9.18323 14.9226C9.18323 12.3867 7.12742 10.3313 4.59151 10.3313ZM15.1475 4.59142C15.1475 7.12743 13.0919 9.18334 10.5561 9.18334C8.02019 9.18334 5.96457 7.12743 5.96457 4.59142C5.96457 2.05592 8.02019 0 10.5561 0C13.0919 0 15.1475 2.05592 15.1475 4.59142Z"
      fill="#F06A6A"
    />
  </svg>
);
